import { render, staticRenderFns } from "./BillingDeleteModal.vue?vue&type=template&id=006c6537&scoped=true&"
import script from "./BillingDeleteModal.vue?vue&type=script&lang=js&"
export * from "./BillingDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c6537",
  null
  
)

export default component.exports